import { Component, Input, EventEmitter, Output, OnChanges } from '@angular/core';

@Component({
  selector: 'app-timepicker',
  templateUrl: './timepicker.component.html'
})
export class TimepickerComponent implements OnChanges {
  @Input() field;
  @Input() form;
  @Input() type;
  @Output() controlReady = new EventEmitter<boolean>();

  constructor() {}

  /**
   * A callback method that is invoked if any data-bound properties change
   */
  ngOnChanges() {
    this.notifyControlLoadComplete();
  }

  /**
   * This method will notify when control is ready
   */
  private notifyControlLoadComplete() {
    this.controlReady.emit(true);
  }
}
